
import Block from 'Mixins/Block';

export default Block('container-teaser', {
	fn: {
	},
	onLoad (qComponent) {
		let qItems =  qComponent.child('.component-card');
		if(qItems.length === 2) {
			qComponent.addClass('container-teaser--items-1-1');
		}
		if(qItems.length === 3) {
			qComponent.addClass('container-teaser--items-2-1');
		}
	}
});